import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const ConfigContext = createContext();

export const useConfig = () => useContext(ConfigContext);
export const ConfigProvider = ({ children }) => {
  const [configData, setConfigData] = useState({});
  const [productTypeData, setProductTypeData] = useState([]);
  const [treatmentTypeData, setTreatmentTypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [configResponse, productType, treatmentsType] = await Promise.all(
          [
            axios.get(`${process.env.REACT_APP_API_URL}config`),
            axios.get(`${process.env.REACT_APP_API_URL}productCategory`),
            axios.get(`${process.env.REACT_APP_API_URL}treatments`),
          ],
        );

        setConfigData(configResponse.data.data[0]);
        setProductTypeData(productType.data.data);
        setTreatmentTypeData(treatmentsType.data.data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      }
    };
    if (isLoading) {
      // react-snap crawls in headless Chrome and waits for network idle before
      // snapshotting — the 1200ms delay (added for real users, past the LCP
      // window) would otherwise get baked into the pre-rendered HTML as an
      // empty/loading state. Skip it under react-snap so the snapshot captures
      // real data; real users still get the delayed fetch.
      const isPrerendering = typeof navigator !== 'undefined' && /ReactSnap/.test(navigator.userAgent);
      const id = setTimeout(fetchData, isPrerendering ? 0 : 1200);
      return () => clearTimeout(id);
    }
  }, []);
  return (
    <ConfigContext.Provider
      value={{ configData, productTypeData, treatmentTypeData }}
    >
      {children}
    </ConfigContext.Provider>
  );
};
